<div class="container-fluid navbar-container g-0">
  <!-- <span style="position: absolute; top: 0; left: 0; font-size: 12px">Version: {{ version }}</span> -->
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand" href="https://www.gov.ph/" target="_blank"
        style="color: #000; font-weight: 700"><strong>GOVPH</strong></a>
      <a href="#" class="d-flex align-items-center col-md-6 col-lg-4 mb-2 mb-md-0 text-dark text-decoration-none">
        <img src="assets/baguio-logo-gov.png" width="90px" height="90px" class="city-logo"
           />
        <div style="display: flex; flex-direction: column">
          <span class="city-government">Republic of the Philippines</span>
          <hr style="
              background-color: #198754;
              margin-top: 5px;
              margin-bottom: 5px;
            " />
          <span class="city-name"><strong>City Government of Baguio</strong></span>
        </div>
      </a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
        style="border-color: #198754">
        <img src="/assets/menu.png" alt="" height="25px" width="25px" />
      </button>
      <div class="collapse navbar-collapse collapsed-navbar" id="navbarSupportedContent" style="padding: 1rem;">
        <div class="col-10 navbar-nav">
          <li class="li-nav">
            <a href="#" class="nav-menu p-3">Home</a>
          </li>
          <li class="li-nav" >
            <a href="about-us" class="nav-menu p-3">About</a>
          </li>
          <li class="li-nav">
            <a href="services" class="nav-menu p-3">Services</a>
          </li>
          <li class="li-nav">
            <a href="contact-us" class="nav-menu p-3">Contact Us</a>
          </li>
        </div>
        <div class="navbar-nav ms-auto">
          <button *ngIf="workPASStokenExist == false" mat-raised-button color="primary" (click)="onNavigateLogin()"
            class="text-white">
            Apply Now
          </button>
          <button *ngIf="workPASStokenExist == true" mat-raised-button color="primary" class="text-white"
            (click)="onNavigateDashboard()">
            Dashboard
          </button>
        </div>
      </div>
    </div>
  </nav>
</div>